<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6116 6.35147C20.0802 6.8201 20.0802 7.5799 19.6116 8.04853L10.0116 17.6485C9.54298 18.1172 8.78319 18.1172 8.31456 17.6485L3.51456 12.8485C3.04593 12.3799 3.04593 11.6201 3.51456 11.1515C3.98319 10.6828 4.74298 10.6828 5.21161 11.1515L9.16309 15.1029L17.9146 6.35147C18.3832 5.88284 19.143 5.88284 19.6116 6.35147Z" fill="#00BF8C"/>
    </svg>
</template>
